import { FC } from "react";
import st from "./blog-post-header.module.scss";

interface Props {
  title: string;
}

const BlogPostHeader: FC<Props> = ({ title }) => {
  return (
    <div className={st.headerContainer}>
      <h1 className={st.headerTitle}>{title}</h1>
    </div>
  );
};

export default BlogPostHeader;
